import { createFileRoute } from '@tanstack/react-router';
import PractitionerSettings from '~/components/Settings/PractitionerSettings';
import { userInfoQueryOptions } from '~/services/auth';

export const Route = createFileRoute('/_authed/settings')({
  loader: async ({ context }) => {
    if (context.isAuthenticated) {
      await context.queryClient.ensureQueryData(userInfoQueryOptions(true));
    }
  },
  component: PractitionerSettings,
});
